export const environment = {
  production: true
};



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/environments/environment.prod.ts